import { SnippetTypeConst } from '../../../constants';

export const AllowedCustomSettingsSnippetTypes = [SnippetTypeConst.SUMMARY, SnippetTypeConst.CODE];
